import { SimpleGrid, useRadioGroup } from '@chakra-ui/react'
import { CATEGORIES_OPTIONS } from 'constants/variables/categories'
import CategoryCard from './components/CategoryCard'

type CategoryPickerProps = {
  watch: any
  setValue: any
  columns?: any
}

export default function CategoryPicker({ watch, setValue, columns = [1, 1, 2, 2, 3, 3] }: CategoryPickerProps) {
  const { value, getRadioProps } = useRadioGroup({
    value: watch('category') || '',
    onChange: (value) => setValue('category', value),
  })
  return (
    <SimpleGrid columns={columns} gap={1}>
      {CATEGORIES_OPTIONS.map((category) => (
        <CategoryCard
          key={category.value}
          isCategorySelected={value === category.value}
          {...category}
          {...getRadioProps({ value: category.value })}
        />
      ))}
    </SimpleGrid>
  )
}
